var _polygon, _polygon2, _polygon3, _line, _line2, _line3, _polygon4, _polyline, _polyline2, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _path2, _path3, _circle13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeSimulationRequestRevision48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#888888",
    points: "12.5,14 12.5,25 22.5,19 22.5,8 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.5,
    y1: 20,
    x2: 27.5,
    y2: 30
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2214,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5415,
    style: {
      stopColor: "#E5E5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BEBEBE"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_1_)",
    points: "32.5,25 22.5,31 12.5,25 22.5,19 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -2,
    y1: 12.5,
    x2: 25,
    y2: 39.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6296,
    style: {
      stopColor: "#C7C7C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7792,
    style: {
      stopColor: "#B9B9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9383,
    style: {
      stopColor: "#A2A2A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#999999"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_2_)",
    points: "12.5,25 12.5,14 2.5,8 2.5,30 22.5,42 22.496,31 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6E6E6E",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 12.5,
    y1: 25,
    x2: 2.5,
    y2: 19
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6E6E6E",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 22.5,
    y1: 31,
    x2: 22.5,
    y2: 42
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6E6E6E",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 12.5,
    y1: 36,
    x2: 12.5,
    y2: 14
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.5,
    y1: 3,
    x2: 17.5,
    y2: 13
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2214,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5415,
    style: {
      stopColor: "#E5E5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BEBEBE"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_3_)",
    points: "2.5,8 12.496,2 22.5,8 12.5,14 "
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#6E6E6E",
    strokeMiterlimit: 10,
    points: "22.5,8 12.5,14 2.5,8 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#6E6E6E",
    strokeMiterlimit: 10,
    points: "22.5,31 12.5,25 22.5,19 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#464646",
    strokeMiterlimit: 10,
    d: "M32.5,25l-10-6V8l-10-6l-10,6v22l20,12"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#464646",
    cx: 12.5,
    cy: 2,
    r: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#464646",
    cx: 22.5,
    cy: 8,
    r: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#464646",
    cx: 12.5,
    cy: 14,
    r: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#464646",
    cx: 12.5,
    cy: 25,
    r: 1.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#464646",
    cx: 12.5,
    cy: 36,
    r: 1.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#464646",
    cx: 2.5,
    cy: 8,
    r: 1.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#464646",
    cx: 2.5,
    cy: 19,
    r: 1.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#464646",
    cx: 2.5,
    cy: 30,
    r: 1.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#464646",
    cx: 22.5,
    cy: 42,
    r: 1.5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#464646",
    cx: 22.5,
    cy: 31,
    r: 1.5
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#464646",
    cx: 22.5,
    cy: 19,
    r: 1.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.1612,
    y1: 26.1612,
    x2: 43.8388,
    y2: 43.8388
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#73B4C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1747,
    style: {
      stopColor: "#6AAEC3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4567,
    style: {
      stopColor: "#529EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    style: {
      stopColor: "#2C839F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#147391"
    }
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_4_)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 35,
    cy: 35,
    r: 12.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M35,40.499c-0.827,0-1.5-0.673-1.5-1.5v-1.73c0-1.713,1-3.282,2.547-3.999 c1.047-0.484,1.614-1.583,1.412-2.737c-0.175-0.998-0.994-1.817-1.993-1.993c-0.156-0.027-0.312-0.041-0.467-0.041 c-0.595,0-1.15,0.202-1.605,0.583c-0.567,0.477-0.894,1.175-0.894,1.916c0,0.827-0.673,1.5-1.5,1.5s-1.5-0.673-1.5-1.5 c0-1.629,0.716-3.164,1.965-4.213c0.987-0.83,2.245-1.286,3.542-1.286c0.325,0,0.654,0.029,0.978,0.086 c2.219,0.389,4.041,2.21,4.43,4.429c0.434,2.474-0.844,4.932-3.107,5.978c-0.49,0.227-0.807,0.728-0.807,1.276v1.73 C36.5,39.826,35.827,40.499,35,40.499z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#147391",
    d: "M35.006,26c0.296,0,0.594,0.026,0.891,0.078c2.016,0.354,3.671,2.008,4.024,4.023 c0.395,2.25-0.768,4.487-2.825,5.438C36.431,35.847,36,36.526,36,37.269v1.73c0,0.552-0.447,1-1,1c-0.553,0-1-0.448-1-1v-1.73 c0-1.519,0.886-2.91,2.257-3.545c1.256-0.58,1.937-1.897,1.694-3.277c-0.21-1.202-1.197-2.188-2.399-2.399 C35.366,28.016,35.181,28,34.999,28c-0.707,0-1.377,0.239-1.927,0.7C32.391,29.272,32,30.11,32,30.999c0,0.552-0.447,1-1,1 c-0.553,0-1-0.448-1-1c0-1.481,0.651-2.877,1.786-3.83C32.693,26.408,33.831,26,35.006,26 M35.007,25L35.007,25 c-1.414,0-2.786,0.498-3.864,1.403C29.781,27.547,29,29.222,29,30.999c0,1.103,0.897,2,2,2c1.103,0,2-0.897,2-2 c0-0.593,0.261-1.151,0.715-1.533C34.079,29.161,34.523,29,34.999,29c0.126,0,0.254,0.011,0.382,0.033 c0.78,0.137,1.448,0.804,1.584,1.586c0.163,0.927-0.291,1.81-1.129,2.197C34.113,33.614,33,35.362,33,37.269v1.73 c0,1.103,0.897,2,2,2c1.103,0,2-0.897,2-2v-1.73c0-0.354,0.203-0.677,0.517-0.822c2.469-1.141,3.863-3.822,3.39-6.518 c-0.425-2.422-2.414-4.41-4.837-4.835C35.719,25.031,35.361,25,35.007,25L35.007,25z"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    stroke: "#147391",
    strokeMiterlimit: 10,
    cx: 35,
    cy: 43,
    r: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeSimulationRequestRevision48);
export default __webpack_public_path__ + "static/media/typeSimulationRequestRevision48.0667e47642c949db8c8edb7c5c9b2937.svg";
export { ForwardRef as ReactComponent };